/* eslint-disable */
import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Paging from '../../component/Inc/Paging';
import PopCallRegister from './_PopCallRegister';
function PopCallStatus(props) {
  const {open, close} = props;
  const [callRegister, setCallRegister] = useState(false);
  return (
    <Modal open={open} close={close} popSize="l">
      <div className="pop_tit__wrap pd0">
        <h2 className="pop_tit">전화수신 목록</h2>
        <button
          onClick={() => {
            setCallRegister(true);
          }}
          className="com_btn orange s btn_plus"
        >
          전화수신 등록
        </button>
      </div>
      <div className="content_container scroll">
        <table className="com_board_list">
          <colgroup>
            <col width="10%" />
            <col width="15%" />
            <col width="10%" />
            <col width="10%" />
            <col width="30%" />
            <col width="10%" />
            <col width="10%" />
          </colgroup>
          <thead>
            <tr>
              <th>수신일</th>
              <th>발신번호</th>
              <th>발신자</th>
              <th>비고</th>
              <th>내용</th>
              <th>수신자</th>
              <th>확인자</th>
            </tr>
          </thead>
          <tbody>
            <tr className="selected">
              <td className="td_date">2023.08.25</td>
              <td>010-2134-2333</td>
              <td>김학생103(부폰)</td>
              <td className="td_point">비회원 전화</td>
              <td>학생이 산만하다고 합니다.</td>
              <td>
                <button className="btn_link">김등록103</button>
              </td>
              <td>
                <button className="btn_link blue">홍길동103</button>
              </td>
            </tr>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i, idx) => {
              return (
                <tr key={idx}>
                  <td className="td_date">2023.08.25</td>
                  <td>010-2134-2333</td>
                  <td>김학생103(부폰)</td>
                  <td>협력업체</td>
                  <td>학생이 산만하다고 합니다.</td>
                  <td>
                    <button className="btn_link">김등록103</button>
                  </td>
                  <td>
                    <button className="btn_link blue">홍길동103</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Paging />
      </div>

      <PopCallRegister open={callRegister} close={() => setCallRegister(false)} />
    </Modal>
  );
}

export default PopCallStatus;
